import { c as _c } from "react/compiler-runtime";
import { handleCopiedLinkFlat } from '@lib/store/slices/ComponentsSlice';
import { useDispatch } from 'react-redux';
import style from './ButtonsShare.module.scss';
function ButtonsShare() {
  const $ = _c(8);
  const dispatch = useDispatch();
  let t0;
  if ($[0] !== dispatch) {
    t0 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(window.location.href);
        dispatch(handleCopiedLinkFlat(true));
        setTimeout(() => dispatch(handleCopiedLinkFlat(false)), 3000);
      } catch (t1) {
        const err = t1;
        console.error("Failed to copy: ", err);
      }
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const copy = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <a className={style.container__option} href={`https://telegram.me/share/url?url=${window.location.href}&text=${document.title}`} target="_blank" rel="noreferrer"><svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0.962129 4.93108C4.72034 3.31457 7.22631 2.2489 8.48053 1.734C12.0605 0.2639 12.8045 0.00850652 13.2895 9.23754e-05C13.3959 -0.00178843 13.6345 0.0242957 13.7889 0.148033C13.9191 0.252517 13.9552 0.393676 13.9726 0.492716C13.9894 0.591755 14.0107 0.817452 13.9939 0.993753C13.7998 3.00622 12.9604 7.88998 12.5332 10.144C12.3526 11.0978 11.9967 11.4175 11.6522 11.4489C10.9038 11.5169 10.3351 10.9604 9.61002 10.4911C8.47557 9.75688 7.83461 9.2998 6.73333 8.58326C5.4603 7.75521 6.28539 7.30005 7.011 6.55629C7.20057 6.36163 10.499 3.3996 10.5628 3.1309C10.5712 3.09729 10.5782 2.97202 10.5029 2.90589C10.4277 2.83977 10.3163 2.86239 10.2361 2.88035C10.1223 2.90584 8.30977 4.08862 4.79854 6.4287C4.28379 6.77749 3.81804 6.9474 3.40029 6.93849C2.93998 6.92869 2.0545 6.68156 1.39621 6.47032C0.588931 6.21126 -0.0525309 6.07426 0.00339924 5.63425C0.0326017 5.40509 0.351847 5.17068 0.962129 4.93108Z" fill="white" /></svg><p>Телеграм</p></a>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <a className={style.container__option} href={`https://vk.com/share.php?url=${window.location.href}`} target="_blank" rel="noreferrer"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0.982412 0.982412C0 1.96482 0 3.546 0 6.70833V7.29167C0 10.454 0 12.0352 0.982412 13.0176C1.96482 14 3.546 14 6.70833 14H7.29167C10.454 14 12.0352 14 13.0176 13.0176C14 12.0352 14 10.454 14 7.29167V6.70833C14 3.546 14 1.96482 13.0176 0.982412C12.0352 0 10.454 0 7.29167 0H6.70833C3.546 0 1.96482 0 0.982412 0.982412ZM2.77086 4.375H3.79193C4.05288 4.375 4.15106 4.48919 4.24891 4.77187C4.7483 6.22624 5.59032 7.49726 5.93647 7.49726C6.06626 7.49726 6.12582 7.4375 6.12582 7.10792V5.60461C6.10237 5.1767 5.95286 4.99164 5.84211 4.85459C5.77372 4.76992 5.72011 4.70359 5.72011 4.60965C5.72011 4.49546 5.8177 4.375 5.97992 4.375H7.58447C7.80086 4.375 7.8762 4.49067 7.8762 4.75026V6.77265C7.8762 6.98892 7.97014 7.06463 8.03504 7.06463C8.16486 7.06463 8.27304 6.98892 8.51104 6.751C9.24662 5.92906 9.76585 4.66369 9.76585 4.66369C9.83077 4.51232 9.95047 4.375 10.2101 4.375H11.2312C11.5399 4.375 11.6048 4.53393 11.5399 4.75026C11.4101 5.34505 10.1661 7.0971 10.1661 7.0971C10.0579 7.27011 10.0147 7.35665 10.1661 7.55131C10.2194 7.62598 10.3332 7.73742 10.4635 7.86494C10.5973 7.99604 10.7486 8.14418 10.8692 8.28675C11.3079 8.78004 11.6384 9.19622 11.7305 9.48305C11.8146 9.77083 11.6688 9.91667 11.377 9.91667H10.3559C10.0825 9.91667 9.94475 9.76351 9.64717 9.43256C9.52102 9.29227 9.36617 9.12004 9.16008 8.914C8.55429 8.33 8.29468 8.25428 8.14322 8.25428C7.93771 8.25428 7.87622 8.3125 7.87622 8.60417V9.51965C7.87622 9.77083 7.79593 9.91667 7.14688 9.91667C6.06512 9.91667 4.87635 9.26007 4.03258 8.0488C2.76694 6.27515 2.42077 4.9341 2.42077 4.66369C2.42077 4.51232 2.47913 4.375 2.77086 4.375Z" fill="white" /></svg><p>Вконтакте</p></a>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M3.38853 0H14V10.6115H3.38853V0ZM0 3.44458H2.8V11.2007H10.6119V14.0561H0.000450644V3.44458H0Z" fill="white" /></svg>;
    t4 = <p>Скопировать ссылку</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== copy) {
    t5 = <div className={style.container}>{t1}{t2}<div className={style.container__option} target="_blank" rel="noreferrer" onClick={copy}>{t3}{t4}</div></div>;
    $[6] = copy;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
export default ButtonsShare;